// src/pages/letters/index.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import './Letters.css';
import LettersSkeleton from './LettersSkeleton';

const Letters = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  const show = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/letters');
        setItems(res.data?.letters || []);
      } catch (err) {
        console.error('خطا در دریافت نامه‌ها:', err);
        show('خطا در دریافت نامه‌ها', 'danger');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  const handleDelete = async (id) => {
    if (!window.confirm('این نامه حذف شود؟')) return;
    setDeletingId(id);
    try {
      await api.post(`/letters/${id}/delete`);
      setItems((prev) => prev.filter((l) => l.id !== id));
      show('نامه حذف شد', 'success');
    } catch (err) {
      show(err.response?.data?.error || 'خطا در حذف نامه', 'danger');
    } finally {
      setDeletingId(null);
    }
  };

  const q = query.trim();
  const filtered = q
    ? items.filter((l) =>
        [l.subject, l.recipientName, l.recipientPosition, String(l.serial)].some((v) =>
          (v || '').includes(q)
        )
      )
    : items;

if (loading) return <LettersSkeleton />;
  return (
    <>
      {message && (
        <div className={messageType === 'danger' ? 'toast-danger' : 'toast-success'}>
          {message}
        </div>
      )}

      <div className="card">
        <div className="card-header-row">
          <h2>لیست نامه‌ها</h2>
          <Link className="btn" to="/dashboard/letters/new">
            <i className="fa-solid fa-plus" /> نامه جدید
          </Link>
        </div>

        {items.length > 0 && (
          <div className="lt-search">
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="جستجو در موضوع، گیرنده یا شماره نامه..."
              autoComplete="off"
            />
          </div>
        )}

        {items.length === 0 ? (
          <div className="empty">هنوز نامه‌ای ثبت نشده است.</div>
        ) : filtered.length === 0 ? (
          <div className="empty">نامه‌ای با این مشخصات پیدا نشد.</div>
        ) : (
          filtered.map((l) => {
            const to = [l.recipientName, l.recipientPosition].filter(Boolean).join(' — ');
            return (
              <div className="list-item" key={l.id}>
                <div>
                  <div>
                    <b>{l.subject}</b>{' '}
                    <span className="badge">شماره {l.serial}</span>{' '}
                    <span className="badge">{l.date}</span>
                  </div>
                  <div className="muted">{to ? `گیرنده: ${to}` : 'بدون گیرنده'}</div>
                </div>

                <div className="row-actions">
                  <Link
                    className="btn secondary small"
                    target="_blank"
                    rel="noopener noreferrer"
                    to={`/dashboard/letters/${l.id}/print`}
                  >
                    <i className="fa-solid fa-print" /> چاپ
                  </Link>
                  <Link
                    className="btn secondary small"
                    to={`/dashboard/letters/${l.id}/edit`}
                  >
                    <i className="fa-solid fa-pen" /> ویرایش
                  </Link>
                  <button
                    type="button"
                    className="btn danger small"
                    onClick={() => handleDelete(l.id)}
                    disabled={deletingId === l.id}
                  >
                    {deletingId !== l.id && <i className="fa-solid fa-trash" />}
                    {deletingId === l.id ? 'در حال حذف...' : 'حذف'}
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default Letters;